/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
import {html} from 'htm/preact';

/*:: type IconProps = {
  +color?: string,
}; */

export function Twitter({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-twitter0"
      ...${props}
    >
      <path
        fill=${color}
        d="M28 8.557a9.913 9.913 0 0 1-2.828.775 4.93 4.93 0 0 0 2.166-2.725 9.738 9.738 0 0 1-3.13 1.194 4.92 4.92 0 0 0-3.593-1.55 4.924 4.924 0 0 0-4.794 6.049c-4.09-.21-7.72-2.17-10.15-5.15a4.942 4.942 0 0 0-.665 2.477c0 1.71.87 3.214 2.19 4.1a4.968 4.968 0 0 1-2.23-.616v.06c0 2.39 1.7 4.38 3.952 4.83-.414.115-.85.174-1.297.174-.318 0-.626-.03-.928-.086a4.935 4.935 0 0 0 4.6 3.42 9.893 9.893 0 0 1-6.114 2.107c-.398 0-.79-.023-1.175-.068a13.953 13.953 0 0 0 7.55 2.213c9.056 0 14.01-7.507 14.01-14.013 0-.213-.005-.426-.015-.637.96-.695 1.795-1.56 2.455-2.55z"
      />
    </svg>
  `;
}
export function Facebook({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-facebook0"
      ...${props}
    >
      <path
        fill=${color}
        d="M17.78 27.5V17.008h3.522l.527-4.09h-4.05v-2.61c0-1.182.33-1.99 2.023-1.99h2.166V4.66c-.375-.05-1.66-.16-3.155-.16-3.123 0-5.26 1.905-5.26 5.405v3.016h-3.53v4.09h3.53V27.5h4.223z"
      />
    </svg>
  `;
}
export function Email({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-email"
      ...${props}
    >
      <path
        fill=${color}
        d="M26 21.25v-9s-9.1 6.35-9.984 6.68C15.144 18.616 6 12.25 6 12.25v9c0 1.25.266 1.5 1.5 1.5h17c1.266 0 1.5-.22 1.5-1.5zm-.015-10.765c0-.91-.265-1.235-1.485-1.235h-17c-1.255 0-1.5.39-1.5 1.3l.015.14s9.035 6.22 10 6.56c1.02-.395 9.985-6.7 9.985-6.7l-.015-.065z"
      />
    </svg>
  `;
}
export function Qrcode({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-qrcode"
      ...${props}
    >
      <path
        fill="none"
        stroke=${color}
        strokeWidth="2"
        strokeLinecap="butt"
        d="M3 3h8v8h-8v-8zM6 7h2M21 3h8v8h-8v-8zM24 7h2M3 21h8v8h-8v-8zM6 25h2M18 3h-3v4h2v4h-2v3M2 15h2m2 0h4m6 0h2m2 0h4m4 0h2M4 17h2m2 0h8m6 0h2m2 0h4M14 19h2m2 0h2m6 0h2M16 21h2m2 0h8M14 23h2m2 0h2m4 0h2m2 0h2M14 25h4m2 0h2m2 0h4M14 27h2m6 0h2m4 0h2M16 29h8m2 0h2"
      />
    </svg>
  `;
}
export function ListLarge({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-list-large"
      ...${props}
    >
      <path
        fill=${color}
        d="M4 4v6h6v-6zm8 0v6h16v-6zm-8 9v6h6v-6zm8 0v6h16v-6zm-8 9v6h6v-6zm8 0v6h16v-6z"
      />
    </svg>
  `;
}
export function ListMedium({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-list-medium"
      ...${props}
    >
      <path
        fill=${color}
        d="M4 4v5h5v-5zm7 0v5h18v-5zm-7 6.3v5h5v-5zm7 0v5h18v-5zm-7 6.3v5h5v-5zm7 0v5h18v-5zm-7 6.4v5h5v-5zm7 0v5h18v-5z"
      />
    </svg>
  `;
}
export function ListSmall({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-list-small"
      ...${props}
    >
      <path
        fill=${color}
        d="M4 4v4h24v-4zm0 5v4h24v-4zm0 5v4h24v-4zm0 5v4h24v-4zm0 5v4h24v-4z"
      />
    </svg>
  `;
}
export function ExternalLink({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-external-link"
      ...${props}
    >
      <path
        fill=${color}
        stroke=${color}
        strokeWidth="3"
        strokeLinejoin="round"
        d="M9 26l-3 -3l13 -13l-4 -4h11v11l-4 -4z"
      />
    </svg>
  `;
}
export function ExternalLink2({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-external-link2"
      ...${props}
    >
      <path
        fill=${color}
        d="M24 18.5v5c0 2.484-2.016 4.5-4.5 4.5h-13c-2.484 0-4.5-2.016-4.5-4.5v-13c0-2.484 2.016-4.5 4.5-4.5h11c0.281 0 0.5 0.219 0.5 0.5v1c0 0.281-0.219 0.5-0.5 0.5h-11c-1.375 0-2.5 1.125-2.5 2.5v13c0 1.375 1.125 2.5 2.5 2.5h13c1.375 0 2.5-1.125 2.5-2.5v-5c0-0.281 0.219-0.5 0.5-0.5h1c0.281 0 0.5 0.219 0.5 0.5zM30 5v8c0 0.547-0.453 1-1 1-0.266 0-0.516-0.109-0.703-0.297l-2.75-2.75-10.187 10.187c-0.094 0.094-0.234 0.156-0.359 0.156s-0.266-0.063-0.359-0.156l-1.781-1.781c-0.094-0.094-0.156-0.234-0.156-0.359s0.063-0.266 0.156-0.359l10.187-10.187-2.75-2.75c-0.187-0.187-0.297-0.438-0.297-0.703 0-0.547 0.453-1 1-1h8c0.547 0 1 0.453 1 1z"
      />
    </svg>
  `;
}
export function Ex({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-ex"
      fill="none"
      stroke=${color}
      strokeWidth="2.5"
      strokeLinecap="round"
      ...${props}
    >
      <path d="m8 8 20 20m0-20l-20 20" />
    </svg>
  `;
}
export function Search({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-search"
      fill="none"
      stroke=${color}
      strokeWidth="2.5"
      strokeLinecap="round"
      ...${props}
    >
      <path d="m18 18 10 10" />
      <circle cx="12" cy="12" r="6.5" />
    </svg>
  `;
}
export function Back({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-back"
      ...${props}
    >
      <path
        fill="none"
        stroke=${color}
        strokeWidth="2.5"
        d="M22 4l-12 12l12 12"
      />
    </svg>
  `;
}
export function User({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-6 -2 32 32"
      className="icon icon-user"
      ...${props}
    >
      <path
        fill=${color}
        d="M20 21.859c0 2.281-1.5 4.141-3.328 4.141h-13.344c-1.828 0-3.328-1.859-3.328-4.141 0-4.109 1.016-8.859 5.109-8.859 1.266 1.234 2.984 2 4.891 2s3.625-0.766 4.891-2c4.094 0 5.109 4.75 5.109 8.859zM16 8c0 3.313-2.688 6-6 6s-6-2.688-6-6 2.688-6 6-6 6 2.688 6 6z"
      />
    </svg>
  `;
}
export function Power({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-4 -2 32 32"
      className="icon icon-power"
      ...${props}
    >
      <path
        fill=${color}
        d="M24 14c0 6.609-5.391 12-12 12s-12-5.391-12-12c0-3.797 1.75-7.297 4.797-9.578 0.891-0.672 2.141-0.5 2.797 0.391 0.672 0.875 0.484 2.141-0.391 2.797-2.031 1.531-3.203 3.859-3.203 6.391 0 4.406 3.594 8 8 8s8-3.594 8-8c0-2.531-1.172-4.859-3.203-6.391-0.875-0.656-1.062-1.922-0.391-2.797 0.656-0.891 1.922-1.062 2.797-0.391 3.047 2.281 4.797 5.781 4.797 9.578zM14 2v10c0 1.094-0.906 2-2 2s-2-0.906-2-2v-10c0-1.094 0.906-2 2-2s2 0.906 2 2z"
      />
    </svg>
  `;
}
export function QuestionMark({
  color = 'currentColor',
  ...props
} /*: IconProps */) /*: React$Node */ {
  return html`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className="icon icon-question-mark"
      ...${props}
    >
      <path
        fill=${color}
        d="M21.32 12.5c0 .41-.07.79-.22 1.12-.14.34-.33.65-.55.93-.23.28-.48.54-.76.77a6784.92 6784.92 0 0 0-1.54 1.2c-.22.16-.38.32-.5.46-.04.07-.1.16-.16.3a.96.96 0 0 0-.09.43c0 .42-.13.77-.4 1.04-.26.28-.66.41-1.22.41-.33 0-.61-.05-.83-.15a1.5 1.5 0 0 1-.86-1.4 2.97 2.97 0 0 1 .95-2.25c.28-.27.57-.5.88-.7.32-.2.6-.4.88-.6.28-.22.5-.45.68-.7.18-.27.27-.6.27-1s-.07-.72-.2-.95a1.5 1.5 0 0 0-1.13-.73c-.22-.03-.4-.05-.54-.05-.4 0-.7.06-.94.18-.24.1-.41.25-.54.42-.12.17-.2.36-.23.57-.04.2-.05.4-.05.6 0 .3-.06.56-.18.78a1.74 1.74 0 0 1-1.02.8c-.2.07-.39.1-.56.1-.53 0-.96-.15-1.29-.44-.33-.3-.49-.67-.49-1.13a5.64 5.64 0 0 1 .34-1.8c.13-.37.32-.73.56-1.09.24-.35.56-.68.95-.97.4-.29.87-.52 1.43-.7a6.66 6.66 0 0 1 2.02-.27c.88 0 1.65.12 2.32.36.67.24 1.23.57 1.67 1 .45.42.78.93 1.01 1.52.23.59.34 1.24.34 1.95Zm-3.42 9.88c0 .66-.17 1.15-.5 1.47a2 2 0 0 1-1.42.47c-.63 0-1.1-.16-1.44-.47-.34-.32-.5-.81-.5-1.48 0-.67.16-1.16.5-1.46.33-.3.81-.46 1.44-.46.64 0 1.13.16 1.44.46.32.3.48.8.48 1.46Z"
      />
    </svg>
  `;
}
